import { Alert } from 'antd';
import { useEffect, useRef, useState } from 'react';

export const useTour = flag => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [allowNextStep, setAllowNextStep] = useState({ deviceFlag: false, localMachinesFlag: false });

  useEffect(() => {
    setAllowNextStep(flag);
  }, [flag]);

  const uploadFilesRef = useRef(null);
  const urlRef = useRef(null);
  const mapTypesRef = useRef(null);

  const steps = [
    {
      title: 'Подраздел ТМС',
      description:
        'В разделе TMS осуществляется загрузка и подключение карт в формате MBTiles. Сервис оптимизирован для быстрой и стабильной работы даже на устройствах с ограниченными ресурсами. Простое подключение, быстрая загрузка, полный контроль.',

      target: null,
    },
    {
      title: 'Загрузка ТМС',
      description: (
        <>
          <p>
            Добавьте новую карту на сервер для её дальнейшего использования в приложениях. Введите название карты,
            укажите тип файла и загрузите файл формата MBTiles. После успешной загрузки карта станет доступной для всех
            подключённых устройств.
          </p>
          {!allowNextStep && (
            <Alert message={'Для продолжения просмотра инструкции загрузите карту!'} style={{ marginTop: '10px' }} />
          )}
        </>
      ),
      target: () => document.getElementById('loadMapButton'),
    },
    {
      title: 'Таблица карт',
      description:
        'После успешной загрузки карта отобразится в списке. Как только кнопка «Скачать» станет активной — карта полностью готова к использованию.',
      target: null,
    },
    {
      title: 'URL-ссылка',
      description:
        'Скопируйте автоматически сгенерированную ссылку для подключения карты в приложении. Это обеспечит быстрое подключение и стабильную работу.',
      target: () => urlRef.current,
    },
    {
      title: 'Выберите тип карт',
      description: 'Для упрощённой навигации используйте фильтр по типам.',
      target: () => mapTypesRef.current,
    },
  ];

  const startTour = () => {
    setCurrentStep(0);
    setIsTourOpen(true);
  };

  const handleTourChange = nextStep => {
    if (!allowNextStep && nextStep === 2) {
      return;
    }

    setCurrentStep(nextStep);
  };

  const handleClose = () => {
    setIsTourOpen(false);
  };

  return {
    uploadFilesRef,
    urlRef,
    mapTypesRef,
    steps,
    startTour,
    handleTourChange,
    handleClose,
    currentStep,
    isTourOpen,
  };
};
